class LocationOBJ{
    constructor(id, name, locationUrl, aniTimestamp){
        this.id = id;
        this.name = name;
        this.aniTimestamp = aniTimestamp;
        this.locationUrl = locationUrl;
    }
}

export default LocationOBJ;